
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '@/assets/images/logo_black.png'

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: '회사 소개', path: '/about' },
    { name: '사업 영역', path: '/services' },
    { name: '프로젝트', path: '/projects' },
    { name: '바우처 사업', path: '/voucher' },
    { name: '채용', path: '/recruit' },
    { name: '문의', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src={logo}
              alt="4-lab" 
              className="h-8"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-[#0D9488]'
                      : 'text-[#5EEAD4]'
                    : isScrolled
                    ? 'text-gray-700 hover:text-[#0D9488]'
                    : 'text-gray-200 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <Link
            to="/contact"
            className={`hidden md:inline-flex items-center justify-center px-6 h-10 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'bg-[#0D9488] text-white hover:bg-[#0F766E]'
                : 'bg-white text-[#0D9488] hover:bg-gray-100'
            }`}
          >
            프로젝트 문의
          </Link>
        </div>
      </div>
    </nav>
  );
}
